// src/api/apiHotelRatings.js
import axios from "../utils/axios";

/// Get Hotel Ratings
export const getAllHotelRatings = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("hotel-ratings", { params });
    return data;
};

/// Get Hotel Rating
export const getHotelRating = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`hotel-ratings/${id}`);
    return data;
};

/// Create Hotel Rating
export const createHotelRating = async (req) => {
    try {
        const { data } = await axios.post("hotel-ratings", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createHotelRating error:", error);
        throw error;
    }
};

/// Update Hotel Rating
export const updateHotelRating = async (req, id) => {
    try {
        const { data } = await axios.put(`hotel-ratings/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateHotelRating error:", error);
        throw error;
    }
};

/// Delete Hotel Rating
export const deleteHotelRating = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-ratings/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteHotelRating error:", error);
        throw error;
    }
};

/// Delete All Hotel Ratings
export const deleteAllHotelRatings = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-ratings/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllHotelRatings error:", error);
        throw error;
    }
};

/// Restore Hotel Rating
export const restoreHotelRating = async (id) => {
    try {
        const { data } = await axios.post(`hotel-ratings/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreHotelRating error:", error);
        throw error;
    }
};

/// Restore multiple Hotel Ratings
export const restoreAllHotelRatings = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "hotel-ratings/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllHotelRatings error:", error);
        throw error;
    }
};

/// Force Delete Hotel Rating
export const forceDeleteHotelRating = async (id) => {
    try {
        const { data } = await axios.delete(`hotel-ratings/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteHotelRating error:", error);
        throw error;
    }
};

/// Force Delete multiple Hotel Ratings
export const forceDeleteAllHotelRatings = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotel-ratings/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllHotelRatings error:", error);
        throw error;
    }
};

/// Get Hotel Ratings for Select Dropdown
export const getHotelRatingsForSelect = async () => {
    try {
        const { data } = await axios.get("hotel-ratings/for-select");
        return data;
    } catch (error) {
        console.error("getHotelRatingsForSelect error:", error);
        throw error;
    }
};
